export const ConfigDataOridnary = [
  {
    id: "route_id",
    name: "Route ID",
    isShow: true,
    width: "350px",
    filter: true,
  },
  {
    id: "bus_name",
    name: "Bus Name",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "created_at",
    name: "Created On",
    isShow: true,
    width: "200px",
    filter: true,
    format: "date-time"
  },
  {
    id: "pickup_station_name",
    name: "First station name",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "pickup_time",
    name: "Pickup time",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "destination_station_name",
    name: "Last station name",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "destination_time",
    name: "Pickup time",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "100px",
    filter: true,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details","Update Status", "Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["bus_booking.access_bus_booking_route"]
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["bus_booking.update_bus_booking_route"]
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["bus_booking.delete_bus_booking_route"]

      },
    },
  },
];

export const ConfigDataSpecial = [
  {
    id: "name",
    name: "Special day name",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "start_date",
    name: "Start date",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "end_date",
    name: "End date",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details", "Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["bus_booking.access_special_days"]

      },
      ["Delete"]: {
        id: "Delete",
        permission: ["bus_booking.delete_special_days"]

      },
    },
  },
];
